import TenantConfig from '@/Framework/Tenant/TenantConfig';
import buildUrl from '@/Framework/url/helpers/buildUrl';
import domain from '@framework/config/domain';
import URL from '@/finsight/Router/urlConstants';

const url = {
  getUrl(...uris: (string | string[])[]): string {
    const { hostname } = TenantConfig.fromHostname();
    return buildUrl(domain.protocol, hostname, ...uris);
  },

  getUrlByTenant(tenant, ...uris: (string | string[])[]): string {
    const config = TenantConfig.fromCode(tenant);

    return buildUrl(domain.protocol, config.hostname, ...uris);
  },

  getTraceUrl(): string {
    return this.getUrl(`${ URL.TRACE }-abs`);
  },

  getApiUrl(uris: string | string[] = []): string {
    return this.getUrl('/api', uris);
  },

  getPropagateCallbackUrl(url: string): string {
    const callbackUrl = this.getUrl(url);
    return this.getApiUrl(`/propagate?callbackUrl=${ encodeURIComponent(callbackUrl) }`);
  },
};

export default url;
